import { ShortcutMenu } from './ShortcutMenu';

export { ShortcutMenu };
export default ShortcutMenu;
